import React, { useEffect, useState } from "react";
import { CITIES_DATA } from "../../data/citiesData";
import { useTheme } from "../../contexts/ThemeContext";

// Ícones ----------------------------------------------
const ArrowRightIcon = () => (
  <svg width="29" height="33" viewBox="0 0 29 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8118 5.22589L21.8765 16.5001L10.8118 27.7741" stroke="#ffffff" stroke-width="2" stroke-miterlimit="10" />
    <path d="M7.12329 24.706L7.12329 8.29404" stroke="#ffffff" stroke-width="2" stroke-miterlimit="10" />
  </svg>

);

// Ícone do WhatsApp
const WhatsAppOutlineIcon = () => (
  <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M48.9177 22.5276C47.9808 10.5905 38.4095 1.01637 26.4734 0.0813477C26.3107 0.0689063 26.127 0.0555078 26.0312 0H22.9688C10.9341 0.87377 1.12738 10.1914 0.0823047 22.4548C0.0708203 22.5965 0.0411523 22.7888 0 22.9688V26.0312C0.0555078 26.127 0.0679492 26.3107 0.0813477 26.4734C1.01828 38.4076 10.5924 47.9808 22.5276 48.9177C22.6893 48.9301 22.873 48.9445 22.9688 49H26.0312C26.127 48.9445 26.3107 48.9321 26.4724 48.9196C38.4104 47.9808 47.9769 38.4095 48.9187 26.4724C48.9311 26.3107 48.9445 26.127 49 26.0312V22.9688C48.9445 22.873 48.9311 22.6893 48.9177 22.5276ZM38.7004 29.3483C35.5413 37.5482 25.9241 41.2337 18.0199 36.9835L10.2393 39.0095L12.3122 31.426C9.37603 26.3174 9.76842 19.933 13.3477 15.235C16.883 10.5934 22.8625 8.44197 28.5578 9.87082C37.1625 12.0299 41.8519 21.1695 38.7004 29.3483Z" fill="white" />
    <path d="M27.5931 12.1878C22.7439 11.1293 17.7587 13.162 14.9842 17.194C12.1199 21.3562 12.1065 26.816 14.9795 31.0145L13.7659 35.5327L18.3721 34.322C24.8101 38.4526 33.299 35.8044 36.2485 28.8143C39.1981 21.8222 35.0934 13.8243 27.5931 12.1878ZM32.0117 29.6297C31.1447 30.8068 29.6048 31.3657 28.1377 31.0777C24.2598 30.3149 21.4691 27.9396 19.2038 24.8283C18.5588 23.942 18.0228 23.053 17.7338 21.9954C17.2725 20.3044 17.796 18.5348 19.2191 17.4955C19.3368 17.4094 20.9245 16.9509 21.2968 17.8429L22.4864 20.6881C22.5993 20.9571 22.5773 21.2939 22.3993 21.5303L21.2892 23.0013C22.3898 25.1795 24.2139 26.8026 26.4696 27.7041C26.6189 27.7635 27.0132 27.8228 27.1146 27.7051C27.573 27.1739 27.9932 26.6591 28.4152 26.1145C28.6095 25.8628 28.9291 25.8264 29.2335 25.9738L32.4108 27.5204C32.4673 28.2286 32.4606 29.021 32.0117 29.6297Z" fill="white" />
  </svg>

);

// Ícone de telefone/contato
const ContactOutlineIcon = () => (
  <svg width="50" height="49" viewBox="0 0 50 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26.7397 0.100319L25.9245 0.0369961C25.0634 -0.0311059 24.2047 0.00832156 23.4052 0.047749C10.7956 0.675004 0.668966 10.6955 0.0325062 23.169C-0.655885 36.6281 9.67119 47.9354 23.2337 48.8518H26.1274C26.224 48.7968 26.4075 48.7801 26.5658 48.7681C38.6923 47.8864 48.3708 38.2864 49.2827 26.2957C49.2947 26.1404 49.3104 25.9576 49.366 25.862V22.9993C48.5134 10.956 39.1633 1.06928 26.7397 0.100319ZM37.3735 34.0175L36.0523 35.315C34.3337 37.002 31.8603 37.5839 29.5403 36.9029C27.5102 36.3067 25.6696 35.499 23.869 34.3795C18.6541 31.1393 13.8378 25.8321 11.9731 19.9502C11.2485 17.6635 11.8608 15.1986 13.5503 13.52L15.0938 11.9859C15.4742 11.6072 16.1566 11.5546 16.5684 11.9608L21.1854 16.526C21.6118 16.9466 21.6009 17.6109 21.1903 18.0195L18.4983 20.6958C17.7254 21.4628 17.6106 22.6504 18.2688 23.5429C20.363 26.3853 22.8811 28.8262 25.7892 30.8478C26.7059 31.4846 27.8991 31.346 28.6708 30.5742L31.2637 27.9827C31.6333 27.6123 32.3144 27.5562 32.7371 27.9731L37.3747 32.5682C37.7805 32.9709 37.7624 33.6364 37.3735 34.0175Z" fill="white" />
  </svg>
);


// Formatador de telefone
function formatPhone(phone) {
  if (!phone) return "";
  const cleaned = phone.toString().replace(/\D/g, "");
  if (cleaned.length === 11)
    return cleaned.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2$3-$4");
  if (cleaned.length === 10)
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  return phone;
}

// COMPONENTE PRINCIPAL ----------------------------------------------
export default function ContactDrawer({ city = "", message = "" }) {
  const { theme } = useTheme();
  const citiesArray = Object.values(CITIES_DATA);
  const [isExpanded, setIsExpanded] = useState(() => {
    const saved = sessionStorage.getItem("drawerExpanded");
    return saved !== null ? JSON.parse(saved) : true;
  });

  // Filtra cidades de acordo com o contexto
  const CitiesFilter = citiesArray.filter(c => {

    const ctx = theme?.context?.toLowerCase() || "";

    if (ctx === "") return true;
    if (ctx.includes("respirat")) return c.cpap === true;
    if (ctx.includes("home")) return c.home === true;
    if (ctx.includes("audit")) return c.aud === true;
    return false;
  });

  useEffect(() => {
    sessionStorage.setItem("drawerExpanded", JSON.stringify(isExpanded));
  }, [isExpanded]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("drawerExpanded");
    };
  }, []);
  const [selectedCity, setSelectedCity] = useState(city?.id || "");

  // **Sincroniza selectedCity quando a prop city mudar**
  useEffect(() => {
    if (city?.id) {
      setSelectedCity(city.id);
    }
  }, [city]);

  // Procura a cidade selecionada no array filtrado
  const currentCityData = CitiesFilter.find(c => c.id.toString() === selectedCity.toString()) || null;

  // Só gera o link se houver cidade selecionada
  const whatsappLink = currentCityData
    ? `https://wa.me/${currentCityData.whatsappPhone}?text=${encodeURIComponent(
      message || "Olá! Gostaria de falar com um especialista."
    )}`
    : "#";

  const drawerWidth = "w-[380px]";

  return (
    <div
      className={`fixed top-[290px] right-0 transform -translate-y-1/2 z-50
    ${isExpanded ? "pointer-events-auto" : "pointer-events-none"}`}
    >
      {/* BOTÃO LATERAL */}
      <button
        onClick={() => setIsExpanded(true)}
        className={`fixed top-1/4 right-0 -translate-y-1/2 bg-white/10 backdrop-blur-[10px] flex flex-row shadow-[inset_0_0_10px_1px_rgba(255,255,255,0.6)] w-[90px] h-[130px]
          shadow-lg rounded-l-[5px] flex flex-col items-center justify-center gap-2 py-2 pr-4
          transition-all duration-300 hover:bg-gray-300
          pointer-events-auto
          ${isExpanded ? "opacity-0" : "opacity-100"}`}
      >
        <div className="w-11 h-11 rounded rounded-[14px] p-2 flex items-center justify-center bg-gradient-to-bl from-black/30 to-black/10">
          <WhatsAppOutlineIcon />
        </div>
        <div className="w-11 h-11 rounded rounded-[14px] p-2 flex items-center justify-center bg-gradient-to-bl from-black/30 to-black/10">
          <ContactOutlineIcon />
        </div>
      </button>

      {/* DRAWER */}
      <div
        className={`bg-black/10 backdrop-blur-[10px] text-[12px] flex flex-row shadow-[inset_0_0_10px_1px_rgba(255,255,255,0.6)] rounded-l-lg shadow-2xl overflow-hidden 
          transition-transform duration-500 ease-in-out ${drawerWidth}
          ${isExpanded ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* CONTEÚDO */}
        <div className="p-6 pt-4 space-y-4 text-center">
          {/* DROPDOWN */}
          {!city && (
            <div className="pb-2">
              <label className="block text-lg font-bold text-white pb-4">
                Selecione sua cidade
              </label>
              <div
                className={`flex items-center gap-2 px-4 py-2 rounded-lg shadow-md`}
              >
                <select
                  value={selectedCity}
                  onChange={e => setSelectedCity(e.target.value)}
                  className="w-full p-3 bg-white/0 text-white text-[15px] outline-none focus:outline-none"
                >
                  <option className="text-xl" value="">Escolha...</option>
                  {CitiesFilter.map(c => (
                    <option className="text-xl" key={c.id} value={c.id}>
                      {c.shortName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {/* HORÁRIOS */}
          {currentCityData && (
            <div className="space-y-2">

              <p className="bg-black/10 border border-white/30 backdrop-blur-[15px] shadow-[inset_0_-5px_15px_5px_rgba(255,255,255,0.2)] rounded rounded-2xl shadow-2xl p-1 mt-0 text-white text-[12px] mb-2">Horário de atendimento</p>
              <div className="flex justify-center text-center divide-x">
                {/* Semana */}
                {currentCityData.hoursWeek && (
                  <div className="px-0 pt-0 backdrop-blur-[18px] shadow-[inset_0_0_30px_40px_rgba(255,255,255,8.2)] rounded rounded-2xl shadow-2xl p-1">
                    <p className="bg-black/45 backdrop-blur-[18px] shadow-[inset_0_-12px_18px_5px_rgba(255,255,255,0.8)] rounded rounded-2xl shadow-2xl px-2 py-1.5 text-white font-semibold w-[130px]">Seg a Sex</p>
                    <p className="text-[14px] font-semibold p-1">{currentCityData.hoursWeek}</p>
                  </div>
                )}

                {/* Sábado */}
                {currentCityData.hoursweekend && (
                  <div className="ms-2 px-0 pt-0 backdrop-blur-[18px] shadow-[inset_0_0_30px_40px_rgba(255,255,255,8.2)] rounded rounded-2xl shadow-2xl p-1">
                    <p className="bg-black/45 backdrop-blur-[18px] shadow-[inset_0_-12px_18px_5px_rgba(255,255,255,0.8)] rounded rounded-2xl shadow-2xl px-2 py-1.5 text-white font-semibold w-[130px]">Sábado</p>
                    <p className="text-[14px] font-semibold p-1">{currentCityData.hoursweekend}</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* WHATSAPP */}
          <a
            href={whatsappLink}
            target="_blank"
            className={`bg-gradient-to-bl from-[#10FF6C]/90 to-[#1E9444]/90 border border-white/10 backdrop-blur-[18px] rounded rounded-[17px] shadow-2xl px-1.5 px-1.5 w-[135px]
              flex items-center justify-between shadow-lg transition-colors
              ${!currentCityData && "opacity-40 pointer-events-none"}`}
          >
            <span className="font-semibold text-[14px] text-white px-1">Whatsapp</span>
            <div className="w-8 rounded-full flex items-center justify-center">
              <WhatsAppOutlineIcon />
            </div>
          </a>

          {/* TELEFONE */}
          <a
            href={currentCityData ? `tel:${currentCityData.phone}` : "#"}
            style={{ backgroundColor: theme.progressBar }}
            className={`bg-gradient-to-bl from-[#108AFF] to-[#00394F] border border-white/10 backdrop-blur-[18px] rounded rounded-[17px] shadow-2xl px-1 w-[220px] 
              flex items-center justify-between shadow-lg transition-colors
              ${!currentCityData && "opacity-40 pointer-events-none"}`}
          >
            <span className="font-semibold text-[14px] text-white px-1">Chame a gente agora!</span>
            <div className="w-8 rounded-full p-0 flex items-center justify-center mr-2">
              <ContactOutlineIcon />
            </div>
          </a>
          {/* FECHAR */}
        </div>
        <div className="flex items-center justify-center backdrop-blur-[18px] text-[12px] flex flex-row shadow-[inset_0_2px_15px_1px_rgba(255,255,255,0.6)] shadow-2xl w-[330px]">
          <button
            onClick={() => setIsExpanded(false)}
            className=""
          >
            <div className="w-5 rounded-full flex items-center justify-center">
              <ArrowRightIcon />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}